<template>
  <div class="mb-2">
    <b-row class="align-items-center justify-content-between">
      <b-col cols="9">
        <ministry-breadcrumbs
          :mainTitle="mainTitle"
          :breadcrumbs="breadcrumbs"
        />
      </b-col>
      <b-col style="font-size: medium" v-if="ngoInfo.status">
        الحالة :
        {{ $t(ngoInfo.status) }}
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="9">
        <b-card>
          <div style="position: relative">
            <loading-overlay :loading="loading" />
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mt-1">معلومات الحساب</h4>
              <div class="d-flex align-items-center" v-if="accountValidated">
                <h5 class="text-success mx-1">
                  تمت المصادقة على معلومات الحساب
                </h5>
                <loader-btn
                  v-if="
                    ngoInfo.status === 'info_evaluating' ||
                    ngoInfo.status === 'info_evaluated'
                  "
                  loadingLabel="جارٍ المعالجة..."
                  label="إلغاء المصادقة"
                  icon="XIcon"
                  :loading="working"
                  variant="outline-danger"
                  @click="
                    onValidate(
                      {
                        model_type: 'account',
                        model_id: ngoInfo.estAccount.id,
                      },
                      accountValidated
                    )
                  "
                />
              </div>

              <div v-else>
                <b-button
                  @click="
                    setCommentModal(ngoInfo.estAccount.feedback_content, {
                      model_type: 'account',
                      model_id: ngoInfo.estAccount.id,
                    })
                  "
                  class="mx-50"
                  :variant="
                    ngoInfo.estAccount.feedback_content
                      ? 'warning'
                      : 'outline-warning'
                  "
                >
                  <feather-icon
                    size="15"
                    class="mr-25"
                    icon="MessageSquareIcon"
                  />
                  التعليقات</b-button
                >
                <loader-btn
                  loadingLabel="جارٍ المعالجة..."
                  label="المصادقة"
                  icon="CheckCircleIcon"
                  :loading="working"
                  variant="success"
                  @click="
                    onValidate(
                      {
                        model_type: 'account',
                        model_id: ngoInfo.estAccount.id,
                      },
                      accountValidated
                    )
                  "
                />
              </div>
            </div>
            <hr />
            <b-row>
              <b-col
                xl="3"
                lg="4"
                sm="6"
                v-for="(val, key) in filteredObj(ngoInfo.estAccount)"
                :key="key"
                v-if="
                  (typeof val === 'string' || typeof val === 'number') &&
                  key !== 'feedback_content' &&
                  key !== 'history'
                "
              >
                <info-card
                  :label="$t(key)"
                  :value="key === 'status' ? $t(val) : val"
                ></info-card>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mt-1">معلومات المنظمة</h4>
              <div class="d-flex align-items-center" v-if="ngoValidated">
                <h5 class="text-success mx-1">
                  تمت المصادقة على معلومات المنظمة
                </h5>
                <loader-btn
                  v-if="
                    ngoInfo.status === 'info_evaluating' ||
                    ngoInfo.status === 'info_evaluated'
                  "
                  loadingLabel="جارٍ المعالجة..."
                  label="إلغاء المصادقة"
                  icon="XIcon"
                  :loading="working"
                  variant="outline-danger"
                  @click="
                    onValidate(
                      {
                        model_type: 'ngo',
                        model_id: ngoInfo.id,
                      },
                      ngoValidated
                    )
                  "
                />
              </div>

              <div v-else>
                <b-button
                  @click="
                    setCommentModal(ngoInfo.feedback_content, {
                      model_type: 'ngo',
                      model_id: ngoInfo.id,
                    })
                  "
                  class="mx-50"
                  :variant="
                    ngoInfo.feedback_content ? 'warning' : 'outline-warning'
                  "
                >
                  <feather-icon
                    size="15"
                    class="mr-25"
                    icon="MessageSquareIcon"
                  />
                  التعليقات</b-button
                >
                <loader-btn
                  loadingLabel="جارٍ المعالجة..."
                  label="المصادقة"
                  icon="CheckCircleIcon"
                  :loading="working"
                  variant="success"
                  @click="
                    onValidate(
                      {
                        model_type: 'ngo',
                        model_id: ngoInfo.id,
                        accepted,
                      },
                      ngoValidated
                    )
                  "
                />
              </div>
            </div>
            <hr />
            <template v-if="!ngoValidated">
              <h5 class="mb-1">اسم المنظمة المعتمد</h5>
              <div class="d-flex">
                <b-form-radio
                  v-model="accepted"
                  name="accepted-name"
                  value="ngo_name"
                  class="custom-control-success"
                >
                  الاسم الأساسي
                </b-form-radio>
                <b-form-radio
                  v-model="accepted"
                  name="accepted-name"
                  value="fst_alt_ngo_name"
                  class="mx-2 custom-control-success"
                >
                  الاسم البديل الأول
                </b-form-radio>
                <b-form-radio
                  v-model="accepted"
                  name="accepted-name"
                  value="sec_alt_ngo_name"
                  class="custom-control-success"
                >
                  الاسم البديل الثاني
                </b-form-radio>
              </div>
            </template>
            <b-row>
              <b-col
                xl="3"
                lg="4"
                sm="6"
                v-for="(val, key) in ngoInfo"
                :key="key"
                v-if="
                  (typeof val === 'string' || typeof val === 'number') &&
                  key !== 'feedback_content' &&
                  key !== 'history'
                "
              >
                <info-card
                  :class="{
                    'bg-success bg-lighten-5':
                      key === ngoInfo.accepted_ngo_name,
                  }"
                  :label="$t(key)"
                  :value="
                    key.includes('legal_form') ||
                    key.includes('status') ||
                    key.includes('accepted_ngo_name')
                      ? $t(val)
                      : val
                  "
                ></info-card>
              </b-col>
            </b-row>

            <h4 class="mt-2">معلومات الأعضاء المؤسسين</h4>

            <hr />
            <b-row>
              <b-table-lite
                :tbody-tr-class="rowClass"
                :fields="foundersFields"
                :items="ngoInfo.estMembers"
              >
                <template #cell(actions)="{ item }">
                  <small v-if="item.validated" class="text-dark">
                    تمت المصادقة على معلومات العضو
                    <b-button
                      size="sm"
                      @click="
                        onValidate({
                          model_type: 'member',
                          model_id: item.id,
                        })
                      "
                      v-b-tooltip.hover.v-danger.bottom
                      title="إلغاء المصادقة"
                      v-if="
                        ngoInfo.status === 'info_evaluating' ||
                        ngoInfo.status === 'info_evaluated'
                      "
                      variant="danger"
                      class="rounded-circle mx-25 btn-icon"
                    >
                      <feather-icon size="16" icon="XIcon" />
                    </b-button>
                  </small>
                  <div v-else class="d-flex justify-content-end">
                    <b-button
                      size="sm"
                      @click="
                        setCommentModal(item.feedback_content, {
                          model_type: 'member',
                          model_id: item.id,
                        })
                      "
                      v-b-tooltip.hover.v-warning.bottom
                      title="التعليقات"
                      :variant="
                        item.feedback_content ? 'warning' : 'outline-warning'
                      "
                      class="rounded-circle mx-25 btn-icon"
                    >
                      <feather-icon size="16" icon="MessageSquareIcon" />
                    </b-button>
                    <b-button
                      size="sm"
                      @click="
                        onValidate({
                          model_type: 'member',
                          model_id: item.id,
                        })
                      "
                      v-b-tooltip.hover.v-success.bottom
                      title="المصادقة على العضو"
                      variant="outline-success"
                      class="rounded-circle mx-25 btn-icon"
                    >
                      <feather-icon size="16" icon="CheckCircleIcon" />
                    </b-button>
                  </div>
                </template>
              </b-table-lite>
            </b-row>
            <h4 class="mt-1">المستندات</h4>
            <hr />
            <template
              v-if="
                ngoInfo.status !== 'docs_evaluating' &&
                ngoInfo.status !== 'docs_evaluated'
              "
            >
              <h5 class="text-warning">
                سيظهر هذا القسم بعد تغيير حالة المنظمة الى مرحلة تدقيق الوثائق
              </h5>
            </template>
            <template v-else>
              <b-row v-if="ngoInfo.estDocs.length">
                <b-col v-for="(doc, n) in ngoInfo.estDocs" :key="n" cols="2">
                  <b-card
                    :class="doc.validated ? 'text-success' : ''"
                    class="text-center p-0 doc-card"
                  >
                    <feather-icon size="60" icon="FileTextIcon"></feather-icon>
                    <h5
                      :class="doc.validated ? 'text-success' : ''"
                      class="mt-1 font-weight-bold"
                    >
                      {{ `إجراء رقم ${n}.pdf` }}
                    </h5>
                    <div class="d-flex justify-content-center">
                      <b-button
                        size="sm"
                        v-if="!doc.validated"
                        @click="
                          setCommentModal(doc.feedback_content, {
                            model_type: 'doc',
                            model_id: doc.id,
                          })
                        "
                        v-b-tooltip.hover.v-warning.bottom
                        title="التعليقات"
                        :variant="
                          doc.feedback_content ? 'warning' : 'outline-warning'
                        "
                        class="rounded-circle btn-icon"
                      >
                        <feather-icon size="16" icon="MessageSquareIcon" />
                      </b-button>
                      <b-button
                        size="sm"
                        v-b-toggle.doc-view
                        @mousedown="viewDoc = doc.source"
                        variant="outline-info"
                        class="rounded-circle mx-25 btn-icon"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند"
                      >
                        <feather-icon size="16" icon="EyeIcon" />
                      </b-button>

                      <b-button
                        size="sm"
                        :disabled="doc.validated"
                        @click="
                          onValidate({
                            model_type: 'doc',
                            model_id: doc.id,
                          })
                        "
                        v-b-tooltip.hover.v-success.bottom
                        title="المصادقة على المستند"
                        :variant="doc.validated ? 'success' : 'outline-success'"
                        class="rounded-circle btn-icon"
                      >
                        <feather-icon size="16" icon="CheckCircleIcon" />
                      </b-button>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
              <h6 v-else>لم يتم رفع اي مستند بعد</h6>
            </template>
          </div>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card>
          <div class="mb-2">
            <h4>سجل معلومات الحساب</h4>
            <hr />
            <ministry-log :events="accLog" />
          </div>
          <div class="mb-2">
            <h4>سجل معلومات المنظمة</h4>
            <hr />
            <ministry-log :events="ngoLog" />
          </div>
          <div class="mb-2">
            <h4>سجل معلومات الأعضاء</h4>
            <hr />
            <ministry-log :events="memLog" />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-sidebar
      right
      width="700px"
      shadow
      bg-variant="white"
      backdrop
      id="doc-view"
      lazy
    >
      <div class="h-100 p-1 text-center">
        <FileViewer style="height: 90%" :fileEp="iframeSrc" />
      </div>
    </b-sidebar>
    <b-modal
      title="تعليقات الوزارة"
      footer-class="removed"
      v-model="commentModal"
      centered
      id="comment-modal"
    >
      <form-textarea v-model="comment" />
      <hr />
      <div class="d-flex justify-content-end">
        <loader-btn
          @click="submitFeedback"
          loadingLabel="جاري إرسال..."
          label="إرسال"
          icon="SendIcon"
          :loading="working"
          variant="success"
        />
      </div>
    </b-modal>
    <div
      v-if="allEvaluated && !working && ngoInfo.status !== 'docs_evaluated'"
      class="change-status"
    >
      <loader-btn
        size="lg"
        @click="onChangeStatus"
        loadingLabel="جاري المعالجة..."
        label="تغيير حالة الطلب"
        :loading="working"
        variant="success"
        noIcon
      />
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BSidebar,
  BTableLite,
  BRow,
  BCol,
  BButton,
  BModal,
  BFormRadio,
  VBToggle,
  VBTooltip,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "../../components/MinistryBreadcrumbs.vue";
import InfoCard from "@/components/InfoCard.vue";
import { mapActions, mapGetters } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import MinistryLog from "@/modules/temp-ngo/components/MinistryLog.vue";
export default {
  components: {
    BCard,
    BSidebar,
    BTableLite,
    BRow,
    BCol,
    BButton,
    BModal,
    BFormRadio,
    MinistryBreadcrumbs,
    InfoCard,
    LoadingOverlay,
    FormTextarea,
    LoaderBtn,
    MinistryLog,
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip },

  props: {
    id: String,
  },

  data() {
    return {
      comment: "",
      commentForm: {},
      commentModal: false,
      viewDoc: null,
      accepted: "ngo_name",
      foundersFields: [
        {
          key: "full_name",
          label: "الاسم الكامل",
        },
        {
          key: "id_number",
          label: "الرقم الوطني",
        },
        {
          key: "address",
          label: "عنوان السكن",
        },
        {
          key: "qualifications",
          label: "المؤهل العلمي",
        },
        {
          key: "jobs",
          label: "العمل",
        },
        {
          key: "phone_number",
          label: "رقم الهاتف",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      mainTitle: "طلبات التأسيس",
      breadcrumbs: [
        {
          text: "طلبات التأسيس",
          to: "/ministry/creation-requests",
        },
      ],
    };
  },

  methods: {
    ...mapActions("Ministry/CreationRequests", [
      "fetchNgoInfo",
      "validateInfo",
      "sendFeedback",
      "changeStatus",
    ]),
    getLogMessage(logItem, type, member = null) {
      var op =
        logItem.action_type === "processing"
          ? "تم إضافة تعليق"
          : logItem.action_type === "authenticated"
          ? "تم المصادقة"
          : "تم إلغاء المصادقة";

      var model =
        type === "acc"
          ? "على معلومات الحساب"
          : type === "ngo"
          ? "على معلومات المنظمة"
          : "على معلومات العضو";
      var mem = member ? `"${member}"` : "";

      return `${op} ${model} ${mem}`;
    },
    rowClass(item, type) {
      const colorClass = "bg-success bg-lighten-5";
      if (!item || type !== "row") {
        return;
      }

      // eslint-disable-next-line consistent-return
      if (item.validated) {
        return colorClass;
      }
    },
    setCommentModal(comment, form) {
      this.commentForm = form;
      this.comment = comment;
      this.commentModal = true;
    },
    async submitFeedback() {
      await this.sendFeedback({
        form: { ...this.commentForm, content: this.comment },
        id: this.id,
      });
      this.commentModal = false;
    },
    filteredObj(toFilter) {
      var x = Object.keys(toFilter);
      x.splice(Object.keys(toFilter).indexOf("full_name"), 1);
      x.splice(1, 0, "full_name");

      return x
        .filter((key) => key !== "validated" && key !== "feedback_content")
        .reduce((obj, key) => {
          return Object.assign(obj, {
            [key]: toFilter[key],
          });
        }, {});
    },
    onValidate(payload, cancel) {
      if (cancel)
        this.$bvModal
          .msgBoxConfirm(" هل أنت متأكد من إلفاء المصادقة على المعلومات ؟", {
            title: "تأكيد إلغاء المصادقة على المعلومات",
            size: "sm",
            okVariant: "danger",
            okTitle: "نعم",
            cancelTitle: "لا",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) this.validateInfo({ form: payload, id: this.id });
          });
      else
        this.$bvModal
          .msgBoxConfirm(
            " هل أنت متأكد من المصادقة على المعلومات ؟ لن تتمكن من إضافة تعليقات جديدة بعد المصادقة.",
            {
              title: "تأكيد المصادقة على المعلومات",
              size: "sm",
              okVariant: "success",
              okTitle: "نعم",
              cancelTitle: "لا",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value) this.validateInfo({ form: payload, id: this.id });
          });
    },
    onChangeStatus() {
      var status_message = `الحالة الحالية : ${
        this.ngoInfo.status === "info_evaluating"
          ? "تدقيق البيانات"
          : "تدقيق الوثائق"
      }  ,  
       الحالة الجديدة : ${
         this.ngoInfo.status === "info_evaluating"
           ? "تدقيق الوثائق"
           : "تم تصديق كافة المعلومات و الوثائق"
       } `;
      this.$bvModal
        .msgBoxConfirm(
          ` هل أنت متأكد من تغيير حالة الطلب ؟ لن تتمكن من اضافة تعليق أو إلغاء المصادقة على أي من معلومات المنظمة أو الحساب أو الأعضاء.\n ${status_message}`,
          {
            title: "تأكيد تغيير حالة الطلب",
            size: "sm",
            okVariant: "success",
            okTitle: "نعم",
            cancelTitle: "لا",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) this.changeStatus(this.id);
        });
    },
  },

  computed: {
    ...mapGetters("Ministry/CreationRequests", [
      "loading",
      "working",
      "ngoInfo",
      "events",
    ]),
    allEvaluated() {
      if (this.ngoInfo.estAccount) {
        var flag = true;
        this.ngoInfo.estMembers.forEach((element) => {
          if (!element.validated) flag = false;
        });

        return (
          this.ngoInfo.validated && this.ngoInfo.estAccount.validated && flag
        );
      }
    },
    iframeSrc() {
      return this.viewDoc ? this.viewDoc : "";
    },
    accLog() {
      return this.events.accountInfo
        ? this.events.accountInfo.map((el) => {
            return {
              ...el,
              message: this.getLogMessage(el, "acc"),
            };
          })
        : [];
    },
    ngoLog() {
      return this.events.ngoInfo
        ? this.events.ngoInfo.map((el) => {
            return {
              ...el,
              message: this.getLogMessage(el, "ngo"),
            };
          })
        : [];
    },
    memLog() {
      if (this.events.founders) {
        var allhistory = [];
        this.events.founders.forEach((el) => {
          el.history.forEach((action) => {
            var x = {
              name: el.name,
              ...action,
              message: this.getLogMessage(action, "mem", el.name),
            };
            allhistory.push(x);
          });
        });

        const sortedArray = allhistory.sort(
          (a, b) =>
            new this.$moment(b.created_at) - new this.$moment(a.created_at)
        );
        return sortedArray;
      }
    },
    accountValidated() {
      return this.ngoInfo.estAccount.validated;
    },
    ngoValidated() {
      return this.ngoInfo.validated;
    },
  },

  async created() {
    await this.fetchNgoInfo(this.id);
    this.breadcrumbs.push({
      text: this.ngoInfo.ngo_name,
      active: true,
    });
    this.mainTitle = this.ngoInfo.ngo_name;
  },
};
</script>

<style lang="scss">
.change-status {
  position: fixed;
  bottom: 6%;
  z-index: 1031;
  right: 1%;
}
.doc-card {
  transition: all 0.2s ease;
  &:hover {
    opacity: 0.9;
    background-color: whitesmoke;
    cursor: pointer;
  }
}
</style>
